import moment from 'moment-timezone';

import { EventsFilter } from '../interfaces';
import { EventTypeIdentifier, FleetUUIDs, VideoStatus } from '../enums';

const fleetToFilterMap = new Map<FleetUUIDs[], Partial<EventsFilter>>([
  [
    [FleetUUIDs.MTA, FleetUUIDs.MTAReplay],
    {
      dateFrom: moment().subtract(7, 'day').startOf('day').toISOString(),
      dateTo: moment().toISOString(),
      selectedFilters: [EventTypeIdentifier.BUS_LANE_MATCH],
      human_review: true,
      media_statuses: [VideoStatus.publishedStr],
      whitelist: false,
    } as Partial<EventsFilter>,
  ],
  [
    [FleetUUIDs.Chicago],
    {
      dateFrom: moment().subtract(14, 'day').startOf('day').toISOString(),
      dateTo: moment().toISOString(),
    } as Partial<EventsFilter>,
  ],
  [
    [FleetUUIDs.SacRTBusStopShelter, FleetUUIDs.SacRTBusStopShelterActivePilot], // SacRT Bus Stop Shelter
    {
      dateFrom: moment().subtract(24, 'hours').toISOString(),
      dateTo: moment().toISOString(),
      include_tags: true,
      tag_operator: 'or',
      tags: {
        'td:776': 'ev:2233', // Graffiti SacRT bus stop shelter tags
        'td:772': 'ev:2230', // 'Sign missing/faded',
        'td:781': 'ev:2238', // 'Faded / missing advertisements',
        'td:774': 'ev:2231', // 'Pole is broken / missing',
        'td:775': 'ev:2232', // 'Broken glass',
        'td:777': 'ev:2234', // 'Lights out',
        'td:778': 'ev:2235', // 'Garbage overflow',
        // 'td:779': 'ev:2236', // 'Good condition',
        'td:780': 'ev:2237', // 'Other',
        'td:814': 'ev:2271', // Unattended Personal Property
      },
    },
  ],
]);

const cleanFilterToFleet = new Map<FleetUUIDs[], Partial<EventsFilter>>([
  [
    [FleetUUIDs.SacRTBusStopShelter, FleetUUIDs.SacRTBusStopShelterActivePilot], // SacRT Bus Stop Shelter
    {
      include_tags: true,
    },
  ],
]);

export const defaultFilter: EventsFilter = {
  // Events filtering default setting for the Slider,
  // Defines from how many hours from the past the Events should be
  // fetched.
  dateFrom: moment().subtract(1, 'week').startOf('day').toISOString(),
  dateTo: moment().toISOString(),

  // Selected tags for filtering, their identifiers
  selectedFilters: [],

  // Selected license plates
  license_plates: [],

  time_of_day: [0, 24],

  vehicle_types: [],
  active_lanes: [],

  route_ids: [],
  vehicle_ids: [],
  bus_stop_ids: [],
  device_ids: [],
};

export const fleetDefaultFilters = (fleetUUID: FleetUUIDs): EventsFilter => {
  // find the default filter
  // eslint-disable-next-line no-restricted-syntax
  for (const [uuids, filter] of fleetToFilterMap.entries()) {
    if (uuids.includes(fleetUUID)) {
      return { ...defaultFilter, ...filter };
    }
  }

  return { ...defaultFilter };
};

export const fleetCleanFilters = (fleetUUID: FleetUUIDs): EventsFilter => {
  // eslint-disable-next-line no-restricted-syntax
  for (const [uuids, overrides] of cleanFilterToFleet.entries()) {
    if (uuids.includes(fleetUUID)) {
      return { ...defaultFilter, ...overrides };
    }
  }

  return { ...defaultFilter };
};
